import { DragDropContext } from "react-beautiful-dnd";
import App from "./App";
import StateContext from "./StateContext";
import { Hooks } from "./mediaPlayer.hook";

export const Provider = () => {
  const hooks = Hooks();
  return (
    <StateContext.Provider value={hooks}>
      <DragDropContext onDragEnd={hooks.onDragEnd}>
        <App />
      </DragDropContext>
    </StateContext.Provider>
  );
};
